import { spawn } from 'redux-saga/effects';
import { authSaga } from './reducers/auth/saga';
import { userSaga } from './reducers/user/saga';
import { settingsSaga } from './reducers/settings/saga';
import { dashboardSaga } from './reducers/dashboard/saga';
import { ordersSaga } from './reducers/orders/saga';
import { refundsSaga } from './reducers/refunds/saga';
import { ordersSyncSaga } from './reducers/ordersSync/saga';
import { invoicesSaga } from './reducers/invoices/saga';
import { reportsSaga } from './reducers/reports/saga';
import { vatCorrectionsSaga } from './reducers/vatCorrections/saga';
import { paymentMethodsSaga } from './reducers/paymentMethods/saga';
import { paymentsSaga } from './reducers/payments/saga';
import { transactionsSaga } from './reducers/transactions/saga';
import { pricingSaga } from './reducers/pricing/saga';
import { shipmentsSaga } from './reducers/shipments/saga';
import { gpsrSaga } from './reducers/gpsr/saga';
import { eudrSaga } from './reducers/eudr/saga';
import { euDdpSaga } from './reducers/euDdp/saga';
import { publicAttachmentSaga } from './reducers/publicAttachment/saga';
import { emExportsSaga } from './reducers/emExports/saga';
import { ppwrSaga } from './reducers/ppwr/saga';
import { shopifyAppsSaga } from './reducers/shopifyApps/saga';

export function* rootSaga() {
	yield spawn(authSaga);
	yield spawn(userSaga);
	yield spawn(settingsSaga);
	yield spawn(dashboardSaga);
	yield spawn(ordersSaga);
	yield spawn(refundsSaga);
	yield spawn(ordersSyncSaga);
	yield spawn(invoicesSaga);
	yield spawn(reportsSaga);
	yield spawn(vatCorrectionsSaga);
	yield spawn(paymentMethodsSaga);
	yield spawn(paymentsSaga);
	yield spawn(transactionsSaga);
	yield spawn(pricingSaga);
	yield spawn(shipmentsSaga);
	yield spawn(gpsrSaga);
	yield spawn(eudrSaga);
	yield spawn(euDdpSaga);
	yield spawn(publicAttachmentSaga);
	yield spawn(emExportsSaga);
	yield spawn(ppwrSaga);
	yield spawn(shopifyAppsSaga);
}
